var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M24 8c3.59 0 6.84 1.455 9.192 3.808A12.96 12.96 0 0137 21a12.96 12.96 0 01-.996 5H24v-1.806a3.1 3.1 0 00-4.902-2.522L13.038 26h-1.042A12.96 12.96 0 0111 21c0-3.59 1.455-6.84 3.808-9.192A12.96 12.96 0 0124 8z", stroke: "currentColor", strokeWidth: 2, fill: "currentColor" }),
            React.createElement("path", { d: "M11 29h3l6.842-4.887a.1.1 0 01.158.081V29h16a1 1 0 011 1v9a1 1 0 01-1 1H11a1 1 0 01-1-1v-9a1 1 0 011-1z" }),
            React.createElement("path", { d: "M20.981 24.136a.1.1 0 01.019.058V29h16a1 1 0 011 1v9a1 1 0 01-1 1H11a1 1 0 01-1-1v-9a1 1 0 011-1h3l6.842-4.887a.1.1 0 01.14.023zM19 27.886l-3.838 2.741-.521.373H12v7h24v-7H19v-3.114z", fill: "currentColor", fillRule: "nonzero" }))));
});
